module.exports = __webpack_public_path__ + "img/柚子13.a89a15eb.png";